'use client';

import { AnalyticsProvider } from '@/components/analytics/analytics-provider/analytics-provider';
import { FacebookPixel } from '@/components/analytics/facebook-pixel/facebook-pixel';
import { GoogleAnalytics } from '@/components/analytics/google-analytics/google-analytics';
import { LazyMotionProvider } from '@/components/ui/lazy-motion/lazy-motion';
import { DeviceProvider } from '@/context/device-context';
import { ProgressProvider } from '@bprogress/next/app';
import { ReactNode } from 'react';

export const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <ProgressProvider
      height="1px"
      color="#FBC00B"
      options={{ showSpinner: true }}
      spinnerPosition="bottom-right"
      shallowRouting
    >
      <LazyMotionProvider>
        <DeviceProvider>
          {children}
        </DeviceProvider>
      </LazyMotionProvider>
      <GoogleAnalytics />
      <FacebookPixel />
      <AnalyticsProvider />
    </ProgressProvider>
  );
};
